var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50.5,
    height: 49.5,
    viewBox: "0 0 13.361 13.097",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.844 13.097H1.517C.68 13.097 0 12.417 0 11.58V1.517C0 .68.68 0 1.517 0h10.327c.838 0 1.517.68 1.517 1.517V11.58c0 .837-.679 1.517-1.517 1.517",
    fill: "#e47d22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69 8.165h.003zM3.903 7.96L6.62 9.515 9.337 7.96V4.806L6.62 3.251 3.903 4.806zm2.717 2.315a.356.356 0 01-.175-.047l-3.07-1.757a.353.353 0 01-.178-.306V4.6c0-.126.068-.243.178-.306l3.07-1.757a.353.353 0 01.35 0l3.07 1.757c.11.063.177.18.177.306v3.564a.353.353 0 01-.177.306l-3.07 1.757a.355.355 0 01-.175.047",
    fill: "#c35200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42 4.522l-.8-.458-2.012 1.151v2.336l1.437.822z",
    fill: "#fcffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.804 9.048L3.903 7.96V4.806L6.62 3.251l1.041.596.241-.675-1.107-.634a.353.353 0 00-.35 0l-3.07 1.757a.354.354 0 00-.178.307v3.562c0 .127.068.244.178.307l2.188 1.252z",
    fill: "#fcffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M.705 10.98h.77V2.028h11.18v-.86a.462.462 0 00-.461-.462H1.167a.462.462 0 00-.462.461z",
    fill: "#fcffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.779 6.107l-.031.02v2.038c0 .378-.204.73-.532.918l-3.07 1.757a1.06 1.06 0 01-1.051 0L4.61 9.992.705 11.5v.892h11.95v-7.89z",
    fill: "#c35200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBronze);
export default __webpack_public_path__ + "static/media/icon-bronze.ffd5b5e82667fcce9172713bf5ea2a74.svg";
export { ForwardRef as ReactComponent };